module.exports = __webpack_public_path__ + "renwu_banner.png?f6fb6809d1bd7ad0254976ef8aea1969";